import React, { useEffect, useState } from "react";
import { Dropdown, Card, Table, Badge, Col, Button } from "react-bootstrap";
import PageTitle from "../layouts/PageTitle";
import Spinner from "../common/Spinner";
import Pagination from "../common/Pagination";
import { blockUser, getAllUsers } from "../../services/User/UserService";
import dummy from "../../images/Profile_avatar_placeholder_large.png";
import { notifyError, notifyTopRight } from "../common/Toaster";
import Select from "react-select";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import {
  deleteAdvertise,
  disableEnableAdvertise,
  getAdvertise,
} from "../../services/Advertisement/AdvertiseService";
import AddAdvertise from "../modal/AddAdvertise";
export default function Advertisement() {
  const history = useHistory();
  const [loader, setLoader] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [users, setUsers] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [search, setSearch] = useState("");
  const [listLength, setListlenght] = useState("");
  const [limit, setLimit] = useState(10);
  const imgUrl = process.env.REACT_APP_IMAGE_BASE_URL;
  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );
  ///////////////// function to get all users /////////////////////////////////
  const getTableData = async () => {
    setLoader(true);
    try {
      const response = await getAdvertise(currentPage, limit);
      setUsers(response.data.data.advertisemnts);
      setLoader(false);
      const total = response.data.data.count;
      setPageCount(Math.ceil(total / limit));
      setListlenght(response.data.data.count);
    } catch (error) {
      setLoader(false);
      if (error?.response?.data?.statusCode === 401) {
        localStorage.clear("pukkatokenDetails");
        history.push("/login");
      }
    }
  };

  ///////////////// function to block/ unlock user /////////////////////////////////
  const onAction = async (id, isDisable) => {
    setLoader(true);
    try {
      const response = await disableEnableAdvertise(id, isDisable);
      {
        isDisable
          ? notifyTopRight("Disabled Successfully!")
          : notifyTopRight("Enabled Successfully!");
      }
      getTableData();
      setLoader(false);
      console.log(response);
    } catch (error) {
      console.log(error.response, "helooooooooo");
      setLoader(false);
      notifyError(error.response?.data?.message);
      if (error.response?.data?.statusCode === 401) {
        localStorage.clear("pukkatokenDetails");
        history.push("/login");
      }
    }
  };
  ///////////////// function to block/ unlock user /////////////////////////////////
  const onDelete = async (id) => {
    setLoader(true);
    try {
      const response = await deleteAdvertise(id);
      notifyTopRight("Deleted Successfully!");
      getTableData();
      setLoader(false);
      console.log(response);
    } catch (error) {
      console.log(error.response, "helooooooooo");
      setLoader(false);
      notifyError(error.response?.data?.message);
      if (error.response?.data?.statusCode === 401) {
        localStorage.clear("pukkatokenDetails");
        history.push("/login");
      }
    }
  };

  useEffect(() => {
    getTableData();
  }, [currentPage, search,limit]);
  return (
    <div>
      <PageTitle activeMenu="Advertisement" motherMenu="Advertisement" />

      <Card>
        <Card.Header className="d-block">
          <div className="text-right">
            <button
              type="button"
              className="btn btn-primary py-2"
              onClick={() => setShowModal(true)}
            >
              Add +
            </button>
          </div>
        </Card.Header>
        <Card.Body>
          <Table responsive>
            <thead className="text-black">
              <tr>
                <th>
                  <strong>IMAGE</strong>
                </th>
                <th>
                  <strong>NAME</strong>
                </th>
                <th>
                  <strong>Link</strong>
                </th>
                <th>
                  <strong>Status</strong>
                </th>
                <th>
                  <strong>ACTION</strong>
                </th>
              </tr>
            </thead>
            <tbody>
              {users?.map((item, i) => (
                <tr key={i}>
                  <td>
                    <img
                      src={item?.image ? item?.image : dummy}
                      width={70}
                      height={70}
                    />
                  </td>
                  <td>{item?.name ? item?.name : "--"}</td>
                  <td>{item?.link}</td>
                  <td>
                    {" "}
                    {item.isDisable ? (
                      <Badge variant="danger light">Deactive</Badge>
                    ) : (
                      <Badge variant="success light">Active</Badge>
                    )}
                  </td>
                  <td>
                    <Dropdown>
                      <Dropdown.Toggle
                        variant="info light"
                        className="light sharp btn btn-info i-false"
                      >
                        {svg1}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {item.isDisable ? (
                          <Dropdown.Item
                            onClick={() => onAction(item._id, false)}
                          >
                            Enable
                          </Dropdown.Item>
                        ) : (
                          <Dropdown.Item
                            onClick={() => onAction(item._id, true)}
                          >
                            Disable
                          </Dropdown.Item>
                        )}
                        <Dropdown.Item onClick={() => onDelete(item._id)}>
                          {" "}
                          Delete
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          {users?.length === 0 && !loader && (
            <div className="justify-content-center d-flex my-5 ">
              Sorry, Data Not Found!
            </div>
          )}

          {users?.length !== 0 && (
            <div className="card-footer clearfix">
              <div className="d-block d-md-flex justify-content-between align-items-center">
                <div className="dataTables_info mb-2 mb-md-0">
                  Showing {currentPage * limit + 1} to{" "}
                  {listLength > (currentPage + 1) * limit
                    ? (currentPage + 1) * limit
                    : listLength}{" "}
                  of {listLength} entries
                </div>
                <Pagination
                  pageCount={pageCount}
                  pageValue={currentPage}
                  setPage={setCurrentPage}
                />
              </div>
              <div  className="mt-2 mt-md-0">
                <label className="mr-2">Result Per page : </label>
                <select className="" onChange={(e)=>setLimit(e.target.value)}>
                  <option>10</option>
                  <option>20</option>
                  <option>30</option>
                  <option>50</option>
                  <option>100</option>
                </select>
              </div>
            </div>
          )}
        </Card.Body>
      </Card>

      {loader && <Spinner />}
      {showModal && (
        <AddAdvertise
          show={showModal}
          table={getTableData}
          onHide={() => setShowModal(false)}
        />
      )}
    </div>
  );
}
